import cn from "classnames";
import Pagination, { PaginationProps } from "rc-pagination";
import localeInfo from "rc-pagination/es/locale/ru_RU";
import React, { FC } from "react";

import style from "./style.css";

const itemRender: PaginationProps["itemRender"] = (page, type, element) => {
  let item;

  switch (type) {
    case "page":
      item = <a>{page}</a>;
      break;
    case "prev":
      item = <a className={style.prev}>Назад</a>;
      break;
    case "next":
      item = <a className={style.next}>Вперед</a>;
      break;
    default:
      item = element;
  }

  return item;
};

export interface IPaginationProps extends Partial<PaginationProps> {
  disabled?: boolean;
}

const PaginationComponent: FC<IPaginationProps> = ({ className, ...restProps }) => {
  return (
    <Pagination
      className={cn(style.pagination, className)}
      itemRender={itemRender}
      locale={localeInfo}
      showLessItems={true}
      {...restProps}
    />
  );
};

export default PaginationComponent;
